import React from "react";
import { List, ListItem, ListItemText, Typography, Paper } from "@mui/material";
import { alpha } from '@mui/material/styles';

// Project archived: messages are now a static, frozen snapshot of the
// transaction metadata messages — no remote fetch is performed.
const messages = [
  {
    txHash: "755a51bf60d3b8c0a1069153ecd5fd404d1f0403ac2783f3acbabfb029d4efd6",
    message: "From QXT Pool: Thanks for creating and maintaining csnapshots.io",
    blockTime: 1690706891,
  },
  {
    txHash: "3fcc5f9895d3d97839914632fa335fc8075697b2bbfcf6c05b41664d9aadc8d7",
    message: "Thanks from t.me/bantmedia.",
    blockTime: 1712210035,
  },
  {
    txHash: "6073c53105b22d1e19ed89932588205969e76766d0ae12802ea5fb8c0bd4a9d5",
    message: "From Quixote Pool [QXT] thanks for your BC snapshot and website",
    blockTime: 1712764209,
  },
  {
    txHash: "84c099ed02c4de6f5bcd6cffce638dc5e811c71a9f66c746e9391dc7342083f2",
    message: "kenerik at X says: heavy underappreciated service. Thanks <3",
    blockTime: 1744192870,
  },
];

const LatestMessages = () => {
  const formatDateToLocal = (blockTime) => {
    if (!blockTime) return "Unknown Date";
    const date = new Date(blockTime * 1000); // Convert Unix timestamp to milliseconds
    return date.toLocaleString(undefined, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false, // Use 24-hour format
    });
  };

  return (
    <Paper style={{ padding: "20px", margin: "20px" }}>
      <Typography variant="h4" gutterBottom>
        Latest Messages
        <Typography
				marginBottom={3}
				variant='body2'
				sx={{ color: (theme) => alpha(theme.palette.text.primary, 0.5) }}
			>

        (From transaction message/comment metadata)
        </Typography>
      </Typography>
      {messages.length > 0 ? (
        <List>
          {messages.map((msg, index) => (
            <ListItem
              key={index}
              style={{
                backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                borderRadius: "4px",
                marginBottom: "5px",
              }}
            >
              <ListItemText
                primary={
                  <Typography variant="body1">
                    <strong>[{formatDateToLocal(msg.blockTime)}]</strong>: {msg.message}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography>No messages found.</Typography>
      )}
    </Paper>
  );
};

export default LatestMessages;
